import { Component, OnDestroy, OnInit } from '@angular/core';
import { Log } from "ng2-logger";
import { Tool } from "@app/tool/model/tool.model";
import { Subscription } from "rxjs";
import { ToolService } from "@services/tool.service";
import { PagedResponse } from "@models/response.model";
import { StrainMeasurement } from "@app/strain/common/models/strain-registry-measurement.model";
import { HttpResponse } from "@angular/common/http";
import * as FileSaver from "file-saver";
import { StrainReportModel } from "@app/strain/common/models/strain-report.model";

@Component({
    selector: 'app-tool-strain-measurements',
    templateUrl: './tool-strain-measurements.component.html',
    styleUrls: ['./tool-strain-measurements.component.scss']
})
export class ToolStrainMeasurementsComponent implements OnInit, OnDestroy {

    private _logger = Log.create(ToolStrainMeasurementsComponent.name);

    selectedTool: Tool;
    subscription: Subscription;
    isLoading = false;
    downloadedReport: StrainReportModel;

    constructor(private toolService: ToolService) {
        this.subscribeToToolChanges();
    }

    ngOnInit() {
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    private subscribeToToolChanges() {
        this._logger.info('subscribeToToolChanges:: Subscribing to toolsSelected$');
        this.subscription = this.toolService.toolSelectedAsObservable.subscribe(
            (tool) => {
                this.selectedTool = tool;
                if (this.selectedTool && this.selectedTool.id) {
                    this.getMeasurements(this.selectedTool.id);
                }
            },
            (error) => {
                this._logger.error('subscribeToToolChanges:: Subscriber error', error);
            }
        )
    }

    private getMeasurements(id: number) {
        this._logger.info('getToolInterventions:: Retrieving interventions for [selectedTool,tableConfig]');

        this.isLoading = true;
        this.toolService.getStrainMeasurementsForTool(id)
            .subscribe(
                data => {
                    this._logger.info('API Returned data', data);
                    this.selectedTool.strainMeasurements = data;
                    this.isLoading = false;
                },
                error => {
                    this._logger.error('API Returned error', error);
                }
            )
    }

    getToolMeasurements() {
        const measurementPagedResponse = new PagedResponse<StrainMeasurement>();
        measurementPagedResponse.items = this.selectedTool ? this.selectedTool.strainMeasurements : [];
        measurementPagedResponse.total = this.selectedTool && this.selectedTool.strainMeasurements ?
            this.selectedTool.strainMeasurements.length : 0;

        return measurementPagedResponse;
    }

    onReportClick($event: any) {
        this.downloadedReport = $event.report;
        this.toolService.downloadStrainReport(this.downloadedReport.id).subscribe(
            (data: HttpResponse<any>) => {
                if (data.body != null) {
                    this._logger.info('onDownloadToolReport:: API Returned error', data);
                    const blob = new Blob([data.body], {type: data.body.type});
                    FileSaver.saveAs(blob, this.downloadedReport.name);
                }
            },
            (error: any) => {
                this._logger.error('onDownloadToolReport:: API Returned error', error);
            });
    }
}
